export const environment = {
  production: false,
  apiUrl: 'https://dev-api.donatello.rundle.jp/',
  socketUrl: 'https://dev-api.donatello.rundle.jp:5102/',
  // apiUrl: 'http://localhost:5002/',
  // socketUrl: 'http://localhost:5102/',
}
